import { AlertSpecificationOutputData } from './alert-specification-output-data.model';


export class AlertSpecificationSelectByIdOutput implements IAlertSpecificationSelectByIdOutput {
    status!: number;
    message!: string;
    data!: AlertSpecificationOutputData;

    constructor(data?: IAlertSpecificationSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? AlertSpecificationOutputData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AlertSpecificationSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AlertSpecificationSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAlertSpecificationSelectByIdOutput {
    status: number;
    message: string;
    data: AlertSpecificationOutputData;
}

